import {
  DocumentType,
  FragmentType,
  getFragmentData,
  gql,
} from "__generated__/gql";
import AttributeIsCertificationIcon from "components/Shared/AttributeIsCertificationIcon";
import TagList, { TagListProps } from "components/Shared/TagList";

const fragment = gql(/* GraphQL */ `
  fragment AttributeTagListAttribute on Attribute {
    id
    name
    isCertification
  }
`);

type Item = DocumentType<typeof fragment>;

type Props = Omit<TagListProps<Item>, "getKey" | "getLabel" | "items"> & {
  items: FragmentType<typeof fragment>[] | null | undefined;
};

export default function AttributeTagList({ items, ...props }: Props) {
  const attributes = getFragmentData(fragment, items);

  return (
    <TagList
      items={attributes}
      getKey={(attribute) => attribute.id}
      getLabel={(attribute) => (
        <>
          {attribute.name}
          {attribute.isCertification ? (
            <AttributeIsCertificationIcon />
          ) : undefined}
        </>
      )}
      {...props}
    />
  );
}
